
import { key } from 'localforage'; 
import WebOffice from '../../../webOffice/index'; 


export default{
    components: {//自定义组件列表 
        'web-office':WebOffice
	},
    data() {
        
        return {
            breadcrumb:[{
                name:'首页', path:'/home'
            },{
                name:'意见稿列表', path:''
            },{
                name:'意见稿详情', path:''
            }],
            apis:{//接口列表 
                upload: this.$global.baseUrl + 'sh/file/upload',//文件上传   
                save:'oa/official/opinion/save',//保存
                bykey:'oa/official/opinion/byKey',//详情
                fileNumList:'oa/fn/cfg/list', //文号配置列表
                getFileNum:'oa/fn/cfg/getFileNum', 
                sendList: 'oa/official/sendDoc/list',//获取列表
                receiveList: 'oa/official/receive/list',//获取列表 
                getWfTask:'/oa/official/getWFTask',//任务详情
                sign: 'sh/wf/task/sign', //签收任务
            }, 
            editObj:{
                title:"",
                fileKey:"",
                operation:1 ,
                docTitle:''
            },
            wfFlowModel:{
                finish:false,
                turn:false,
            },
            key:"",
            fileList:[],//源文件
            enclosureList:[],//附件 
            userWnd: false,//是否显示人员选择窗口
            rules:{
                fileKey:[{ required: true, message: '请上传源文件', trigger: 'change' }],
                title:[{ required: true, message: '请输入标题', trigger: 'blur' }],
                fileNumStr:[{ required: true, message: '请输入文号', trigger: 'blur' }], 
                timeLimit:[{ required: true, message: '请输入办结时限', trigger: 'blur' }],
            },
            fileNumList:[],
            dialogTableVisible:false,
            selectData:[],
            total:0,
            docData:[],
            params:{
                page:1,
                limit:20, 
                status:3
            },
            WFtask:{}, 
            webShow: false,
            docFileKey:'',
            fileType:".docx"
        }
    },
    props: {
        visible: { 
          type: Boolean,
          default: false
        }, 
        bizKey:String, 
    },
    watch: {
        bizKey() {
            this.find();
        }, 
    },                
    mounted() {  
        this.find(); 
    },                     
    methods: {
        getWfTask(taskKey){ 
            this.$post({
                url: this.apis.getWfTask,
                params:taskKey,  
            }).then(rsp => {
                if(rsp.success){
                    this.WFtask = rsp.retObj; 
                    if(this.WFtask.type==2){
                        this.sign();
                    }
                }
            })
        },
        sign(){
            const me = this;
            me.$post({
                url: me.apis.sign,
                params: me.WFtask.id
            }).then(rsp => {
                if(rsp.success){ 
                    me.$message.success("签收成功");
                }
            })
        },
        find(){
            const me = this;
            me.key = me.bizKey;
            me.$post({
                url: me.apis.bykey,
                params:me.key,  
            }).then(rsp => {
                if(rsp.success){
                    me.editObj=rsp.retObj;
                    if(rsp.retObj.fileInfo){
                        me.fileList.push(rsp.retObj.fileInfo); 
                    }
                    me.$delete(me.editObj,'fileInfo');
                    me.$delete(me.editObj,'enclosureList');
                }
            })
        },
        
        goBack(){ 
            this.$router.go(-1);
        },  
        handlePreview(file){ 
            if(file.path){
                if(file.path.includes(".docx")||file.path.includes(".xlsx")||file.path.includes(".doc")||file.path.includes(".xls")){

                    let {href}  = this.$router.resolve({ 
                        path: "/oa/office/browerDialog",
                        query:{
                            isView:1,
                            bizKey:this.key,
                            fileType:file.path.substring(file.path.lastIndexOf("."), file.path.length),
                            bizType:3,
                            fileId:file.id 
                        }
                    })    
                    this.winDialog=window.open(href,"_blank"," left=0,top=0,width="+ (screen.availWidth - 10) +",height="+ (screen.availHeight-50) +",toolbar=no, menubar=no, scrollbars=no,location=no, status=no");
 
                }else if(file.path.includes(".txt") ||file.path.includes(".pdf") || file.path.includes(".PDF") || file.path.includes(".png") || file.path.includes(".PNG")|| file.path.includes(".jgp") || file.path.includes(".JPG")|| file.path.includes(".gif") || file.path.includes(".GIF")){
                    const url = this.$global.baseUrl + file.path;
                    window.open(url, '_blank');
                }  
                else{
                    const url = this.$global.baseUrl + 'sh/file/download?id=' + file.id;
                    window.open(url, '_blank');
                }
            } 
        }, 
        download(key){
            if(key){ 
                const url = this.$global.baseUrl + 'sh/file/download?id=' + key;
                window.open(url, '_blank');
            }else{
                this.$message.error("未编辑文档,请检查!");
            }
        },
        print(){
            let {href}  = this.$router.resolve({ path: "/oa/official/opinion/print/"+this.key})
            window.open(href, '_blank')  
        },
        callback(){

        }
    },
}


// WEBPACK FOOTER //
// ./src/components/oa/view/official/opinion/view/view.js